// extracted by mini-css-extract-plugin
module.exports = {"LikeButton":"LikeButton_LikeButton__2JXWV","likeIcon":"LikeButton_likeIcon__2jpkE","justBookmarked":"LikeButton_justBookmarked__3e3KM","fade-in":"LikeButton_fade-in__3AjKc"};